import { ConfigProvider } from "antd";
import ptBR from "antd/locale/pt_BR";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.scss';
import PanelLayout from "./common/PanelLayout/PanelLayout";
import ProtectedRoute from "./common/ProtectedRoute/ProtectedRoute";
import PermissionRoute from "./common/PermissionRoute/PermissionRoute";
import Accreditation from "./pages/Accreditation/Accreditation";
import ApiKeyList from "./pages/ApiKeyList/ApiKeyList";
import DisputeManagement from "./pages/DisputeManagement/DisputeManagement";
import ExternalPayment from "./pages/ExternalPayment/ExternalPayment";
import Home from "./pages/Home/Home";
import Login from "./pages/Login/Login";
import NewPassword from "./pages/NewPassword/NewPassword";
import PaymentCreate from "./pages/PaymentCreate/PaymentCreate";
import PaymentInfo from "./pages/PaymentInfo/PaymentInfo";
import PaymentInfoDetails from "./pages/PaymentInfoDetails/PaymentInfoDetails";
import PaymentPlans from "./pages/paymentLink/PaymentLinkListing/PaymentLinkListing";
import RecoverPassword from "./pages/RecoverPassword/RecoverPassword";
import SaleInfo from "./pages/SaleInfo/SaleInfo";
import SalesListing from "./pages/SalesListing/SalesListing";
import ReceivableListing from "./pages/receivables/ReceivableListing/ReceivableListing";
import ReceivableGraphic from "./pages/receivables/ReceivableGraphic/ReceivableGraphic";
import ReceivableInfo from "./pages/receivables/ReceivableInfo/ReceivableInfo";
import SignUp from "./pages/SignUp/SignUp";
import SimulationTax from "./pages/SimulationTax/SimulationTax";
import SplitPlan from "./pages/SplitPlan/SplitPlan";
import SplitPlanDetails from "./pages/SplitPlanDetails/SplitPlanDetails";
import ZoopBasePlan from "./pages/ZoopBasePlan/ZoopBasePlan";
import ZoopBasePlanDetails from "./pages/ZoopBasePlanDetails/ZoopBasePlanDetails";
import WebhookList from "./pages/WebhookList/WebhookList";
import Access from "./pages/access/Access/Access";
import AccessInfo from "./pages/access/AccessInfo/AccessInfo";
import AccountDetails from "./pages/accounts/AccountDetails/AccountDetails";
import Accounts from "./pages/accounts/Accounts/Accounts";
import EventCheckoutDetails from "./pages/events/EventCheckoutDetails/EventCheckoutDetails";
import EventCreate from "./pages/events/EventCreate/EventCreate";
import EventDetails from "./pages/events/EventDetails/EventDetails";
import Events from "./pages/events/Events/Events";
import EventCheckoutSearch from "./pages/events/EventCheckoutSearch/EventCheckoutSearch";
import PriceList from "./pages/priceList/PriceList/PriceList";
import CheckoutTicket from "./pages/tickets/CheckoutTicket/CheckoutTicket";
import ResponseTicket from "./pages/tickets/ResponseTicket/ResponseTicket";
import TicketSelector from "./pages/tickets/TicketSelector/TicketSelector";
import DepositListing from "./pages/deposits/DepositListing/DepositListing";
import DepositInfo from "./pages/deposits/DepositInfo/DepositInfo";
import PointOfSaleListing from "./pages/pointOfSale/PointOfSaleListing/PointOfSaleListing";
import PointOfSaleDetails from "./pages/pointOfSale/PointOfSaleDetails/PointOfSaleDetails";
import GroupsListing from "./pages/groups/GroupsListing/GroupsListing";
import GroupsDetails from "./pages/groups/GroupsDetails/GroupsDetails";
import ManagedAccountsList from "./pages/virtualAccounts/ManagedAccountsList/ManagedAccountsList";
import ManagedAccountDetails from "./pages/virtualAccounts/ManagedAccountDetails/ManagedAccountDetails";
import VirtualAccountDetails from "./pages/virtualAccounts/VirtualAccountDetails/VirtualAccountDetails";
import SubscriptionCreate from "./pages/SubscriptionCreate/SubscriptionCreate";
import SubscriptionListing from "./pages/subscriptions/SubscriptionListing/SubscriptionListing";
import SubscriberDetail from "./pages/subscriptions/SubscriberDetail/SubscriberDetail";
import ExternalSubscription from "./pages/ExternalSubscription/ExternalSubscription";
import SubscriberCancel from "./pages/SubscriberCancel/SubscriberCancel";
import SubscriberPayment from "./pages/SubscriberPayment/SubscriberPayment";
import SubscriberSelfService from "./pages/SubscriberSelfService/SubscriberSelfService";
import Statistics from "./pages/Statistics/Statistics";
import ReceivableDashboard from "./pages/ReceivableDashboard/ReceivableDashboard";
import SystemConfigs from "./pages/system/SystemConfigs/SystemConfigs";
import {startSession} from "../helpers/tracker";

startSession()

dayjs.locale("pt-br");

function App() {
    return (
        <ConfigProvider
            locale={ptBR}
            theme={{
                token: {
                    // Seed Token
                    // colorPrimary: '#00B327',
                },
                components: {
                    Steps: {
                        // colorPrimary: '#1890FF',
                        colorTextBase: '#000000',
                        algorithm: true
                    },
                },
            }}
        >
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={
                        <ProtectedRoute>
                            <PanelLayout><Home /></PanelLayout>
                        </ProtectedRoute>} />
                    <Route path="/dashboard/receivable" element={
                        <ProtectedRoute>
                            <PanelLayout><ReceivableDashboard /></PanelLayout>
                        </ProtectedRoute>} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/listagem-recebiveis" element={<ProtectedRoute>
                        <PanelLayout><ReceivableGraphic /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/listagem-recebiveis/registros" element={<ProtectedRoute>
                        <PanelLayout><ReceivableListing /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/listagem-depositos" element={<ProtectedRoute>
                        <PanelLayout><DepositListing /></PanelLayout>
                    </ProtectedRoute>} />                    <Route path="/terminais-pos" element={<ProtectedRoute>
                        <PanelLayout><PointOfSaleListing /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/terminal-pos/:id" element={<ProtectedRoute>
                        <PanelLayout><PointOfSaleDetails /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/listagem-vendas" element={<ProtectedRoute>
                        <PanelLayout><SalesListing /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/simulador-taxas" element={<ProtectedRoute>
                        <PanelLayout><SimulationTax /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/transacao/:slug?" element={<ProtectedRoute>
                        <PanelLayout><SaleInfo /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/recebivel/:slug?" element={<ProtectedRoute>
                        <PanelLayout><ReceivableInfo /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/deposito/:slug?" element={<ProtectedRoute>
                        <PanelLayout><DepositInfo /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/contas-virtuais" element={<ProtectedRoute>
                        <PanelLayout><ManagedAccountsList /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/conta-gerenciada/:id" element={<ProtectedRoute>
                        <PanelLayout><ManagedAccountDetails /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/conta-gerenciada/:managedAccountId/conta-virtual/:id" element={<ProtectedRoute>
                        <PanelLayout><VirtualAccountDetails /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/conta-virtual/:id" element={<ProtectedRoute>
                        <PanelLayout><VirtualAccountDetails /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/disputas" element={<ProtectedRoute>
                        <PanelLayout><DisputeManagement /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/pagamentos" element={<ProtectedRoute>
                        <PanelLayout><PaymentPlans /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/pagamento/:slug?" element={<ProtectedRoute>
                        <PanelLayout><PaymentInfo /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/detalhe/pagamento/:id?/:idDetails?" element={<ProtectedRoute>
                        <PanelLayout><PaymentInfoDetails /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/planos-e-taxas/detalhe/:slug?" element={<ProtectedRoute>
                        <PanelLayout><SplitPlanDetails copy={false}/></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/planos-e-taxas/duplicar/:slug?" element={<ProtectedRoute>
                        <PanelLayout><SplitPlanDetails copy={true}/></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/pagamento/criar" element={<ProtectedRoute>
                        <PanelLayout><PaymentCreate /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/webhooks" element={<ProtectedRoute>
                        <PanelLayout><WebhookList /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/apikey" element={<ProtectedRoute>
                        <PanelLayout><ApiKeyList /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/planos-e-taxas" element={<ProtectedRoute>
                        <PanelLayout><SplitPlan /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/planos-base-zoop" element={<ProtectedRoute>
                        <PanelLayout><ZoopBasePlan /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/planos-base-zoop/detalhe/:slug?" element={<ProtectedRoute>
                        <PanelLayout><ZoopBasePlanDetails /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/teste" element={<ProtectedRoute>
                        <PanelLayout><PriceList /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/credenciamento" element={<ProtectedRoute>
                        <PanelLayout><Accreditation /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/eventos" element={<ProtectedRoute>
                        <PanelLayout><Events /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/eventos/compras" element={<ProtectedRoute>
                        <PanelLayout><EventCheckoutSearch /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/eventos/criar" element={<ProtectedRoute>
                        <PanelLayout><EventCreate /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/eventos/:accountId/:eventId" element={<ProtectedRoute>
                        <PanelLayout><EventDetails /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/eventos/:accountId/:eventId/compras/:checkoutId" element={<ProtectedRoute>
                        <PanelLayout><EventCheckoutDetails /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/assinaturas" element={<ProtectedRoute>
                        <PanelLayout><SubscriptionListing /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/assinatura/criar" element={<ProtectedRoute>
                        <PanelLayout><SubscriptionCreate /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/assinatura/:id" element={<ProtectedRoute>
                        <PanelLayout><SubscriptionCreate /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/assinatura/:id/assinante/:subscriberId" element={<ProtectedRoute>
                        <PanelLayout><SubscriberDetail /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/evento/:name?/:id?" element={<TicketSelector />} />
                    <Route path="/evento/checkout/:eventID?/:id?" element={<CheckoutTicket />} />
                    <Route path="/evento/pagamento/:eventID?/:checkoutID?" element={<ResponseTicket />} />
                    <Route path="/admin/acessos" element={<ProtectedRoute>
                        <PanelLayout><Access /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/admin/acessos/:slug?" element={<ProtectedRoute>
                        <PanelLayout><AccessInfo /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/perfis" element={<ProtectedRoute>
                        <PanelLayout><GroupsListing /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/perfis/:id" element={<ProtectedRoute>
                        <PanelLayout><GroupsDetails /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/estatisticas" element={<ProtectedRoute>
                        <PanelLayout><Statistics /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/configuracoes-sistema" element={<ProtectedRoute>
                        <PermissionRoute permission="super_user"><PanelLayout><SystemConfigs /></PanelLayout></PermissionRoute>
                    </ProtectedRoute>} />
                    <Route path="/lojistas" element={<ProtectedRoute>
                        <PanelLayout><Accounts /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/lojista/detalhes/:slug?" element={<ProtectedRoute>
                        <PanelLayout><AccountDetails /></PanelLayout>
                    </ProtectedRoute>} />
                    <Route path="/register/:invitationLink?" element={<SignUp />} />
                    <Route path="/reset-password" element={<NewPassword />} />
                    <Route path="/pagar/:slug?" element={<ExternalPayment />} />
                    <Route path="/assinar/:slug?" element={<ExternalSubscription />} />
                    <Route path="/assinar/:planId/:subscriberId" element={<SubscriberSelfService />} />
                    <Route path="/assinar/:planId/:subscriberId/cancelar" element={<SubscriberCancel />} />
                    <Route path="/assinar/:planId/:subscriberId/pagar/:paymentId" element={<SubscriberPayment />} />
                    <Route path="/recovery" element={<RecoverPassword />} />
                </Routes>
            </BrowserRouter>
        </ConfigProvider>
    );
}

export default App;
